import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -1 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.636 0h6.546a1.636 1.636 0 1 1 0 3.273H1.636a1.636 1.636 0 0 1 0-3.273m0 1.09a.545.545 0 0 0 0 1.092h6.546a.545.545 0 0 0 0-1.091zm5.455 3.274h4.363a1.636 1.636 0 1 1 0 3.272H7.091a1.636 1.636 0 1 1 0-3.272m0 1.09a.545.545 0 1 0 0 1.091h4.363a.545.545 0 1 0 0-1.09zm0 3.273h4.363a1.636 1.636 0 1 1 0 3.273H7.091a1.636 1.636 0 1 1 0-3.273m0 1.091a.545.545 0 0 0 0 1.091h4.363a.545.545 0 1 0 0-1.09z"
    }, null, -1)
  ]))]))
}
export default { render: render }